import React, { useState } from 'react';
import '../../styles/JobsPage/JobApplyPopup.css';

const JobApplyPopup = ({ jobTitle, jobId, onClose }) => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        location: '',
        experience: '',
    });

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    const validate = () => {
        const newErrors = {};
        Object.entries(formData).forEach(([key, value]) => {
            if (!value.trim()) {
                newErrors[key] = 'This field is required';
            }
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        setErrors({ ...errors, [e.target.name]: '' });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        const payload = {
            ...formData,
            experience: parseInt(formData.experience),
            jobTitle,
            jobId,
        };

        try {
            setLoading(true);
            const res = await fetch('http://localhost:3000/api/applicants', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });

            if (!res.ok) {
                const errData = await res.json();
                throw new Error(errData.message || 'Failed to submit application');
            }

            const result = await res.json();
            alert(`Application submitted successfully for ${jobTitle}`);
            onClose();
        } catch (err) {
            console.error('Application error:', err);
            alert(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal">
                <button className="close-btn" onClick={onClose}>×</button>

                <h2>Apply for {jobTitle}</h2>
                <form onSubmit={handleSubmit} className="application-form">
                    {['name', 'email', 'phone', 'location', 'experience'].map((field) => (
                        <div key={field} className="form-group">
                            <label htmlFor={field}>{field.charAt(0).toUpperCase() + field.slice(1)}</label>
                            <input
                                type={field === 'email' ? 'email' : field === 'experience' ? 'number' : 'text'}
                                name={field}
                                id={field}
                                min={field === 'experience' ? 0 : undefined}
                                value={formData[field]}
                                onChange={handleChange}
                            />
                            {errors[field] && <span className="error">{errors[field]}</span>}
                        </div>
                    ))}

                    <button type="submit" className="submit-btn" disabled={loading}>
                        {loading ? 'Submitting...' : 'Submit Application'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default JobApplyPopup;
